<ul *ngIf="skyConditions && skyConditions.length > 0; else na" class="sky-conditions">
  <li *ngFor="let layer of skyConditions" class="sky-conditions__layer">
    <span class="sky-conditions__sky-cover" [innerHTML]="layer.skyCover"></span>
    <span class="sky-conditions__cloud-base" *ngIf="layer.cloudBase !== 'None'" [innerHTML]="layer.cloudBase"></span>
  </li>
</ul>
<ng-template #na>
  <div class="sky-conditions__na">N/A</div>
</ng-template>
